<template>
    <div class="product__item | u-margin-bottom">
        <div class="product__item-header product__item-header-overview">
            <div class="u-flex-between">
                <span class="u-margin-bottom-responsive">
                    {{ domain.domain }}
                </span>
            </div>

            <div v-if="productPrice !== null" class="product__item-actions">
                <a
                    v-if="hasPrivateWhoisOption && !domain.private_whois"
                    @click="onChangePrivateWhois()"
                    class="btn btn--small btn--blue u-margin-right">

                    {{ trans('order.choose-privacy') }}
                </a>

                <input
                    required
                    v-if="domain.status === 'transfer'"
                    v-bind:value="domain.transfer_secret"
                    :placeholder="trans('order.renew-code')"
                    @input="onChangeTransferSecret"
                    class="field__input field__input-renew"
                />
                <period-select
                    class="product__item-select product__item-period"
                    :prices="productPrices"
                    :currentPeriod="currentPeriod"
                    :registrationType="orderLineItem.status"
                    @change="setPeriod"
                />

                <price-display :price="productPrice" class="product__item-actions-price" />

                <div class="product__item-delete">
                    <a
                        class="product__item-icon | u-align-self-center"
                        @click="removeService({ type: productType, name: orderLineItem.name, domain: domain.domain })"
                    >
                        <img src="../../assets/feather-icons/trash.svg" />
                    </a>
                </div>
            </div>
        </div>

        <service-overview v-if="addons" :domain="domain" productType="addons" />
        <service-overview v-if="hosting" :domain="domain" productType="hosting" />
        <service-overview v-if="vps" :domain="domain" productType="vps" />
        <service-overview v-if="ssl" :domain="domain" productType="ssl" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import ServiceOverview from '../ServiceOverview.vue';
import PeriodSelect from '@/components/Period/PeriodSelect.vue';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import serviceMixin from '../../mixins/service.js';

export default {
    components: {
        PeriodSelect,
        ServiceOverview,
        PriceDisplay
    },
    mixins: [serviceMixin],
    props: {
        productType: {
            type: String,
            required: false,
            default: 'domains'
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            period: null
        };
    },
    computed: {
        ...mapGetters({
            hostingOrdered: 'order/hosting',
            vpsOrdered: 'order/vps',
            sslOrdered: 'order/ssl',
            addonsOrdered: 'order/addons',
            domainExpansion: 'products/domainExpansion',
        }),

        /**
         * Get the hosting, if any, ordered with the domain.
         *
         * @return {object}
         */
        hosting() {
            return this.hostingOrdered({ domain: this.domain.domain });
        },
        /**
         * Get the vps, if any, ordered with the domain.
         *
         * @return {object}
         */
        vps() {
            return this.vpsOrdered({ domain: this.domain.domain });
        },
        /**
         * Get the ssl, if any, ordered with the domain.
         *
         * @return {object}
         */
        ssl() {
            return this.sslOrdered({ domain: this.domain.domain });
        },
        /**
         * Get the addons, if any, ordered with the domain.
         *
         * @return {object}
         */
        addons() {
            return this.addonsOrdered({ domain: this.domain.domain });
        }
    },
    methods: {
        ...mapActions({
            updatePrivateWhois: 'order/updatePrivateWhois',
            updateTransferSecret: 'order/updateTransferSecret'
        }),
        /**
         * Updates transfer secret entered for domain transfers.
         *
         * @param  {Event} event
         */
        onChangeTransferSecret(event) {
            this.updateTransferSecret({
                domain: this.domain.domain,
                transferSecret: event.target.value
            });
        },

        onChangePrivateWhois() {
            this.updatePrivateWhois({
                domain: this.domain.domain,
                privateWhois: true,
                domainExpansion: this.domainExpansion,
            });
        }
    }
};
</script>
